import DashHeaderOpen from 'components/markup/headers/DashHeaderOpen';
import React, { Component } from "react";
import { Helmet } from 'react-helmet';
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";

class Resources extends Component {

    render() {

        return (
            <>

            <Container>

                <Helmet>
                    <title>Resources</title>
                    <meta name="description" content="Resources" />
                </Helmet>

                <DashHeaderOpen 
                    icon="fas fa-home" 
                    icon_link="/developers/development/backend" 
                    title={<span>Development</span>} breadcrumb_1="Code"  breadcrumb_2="Resources" 
                />
                
                <Card>
                    <CardHeader>
                        <Row className="align-items-center">
                            <Col xs="8">
                                <h3 className="mb-0">Awesome Resources</h3>
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody>

                        <h4>Sharing The Wealth</h4>
                        <p className="text-sm">
                            Below you will find a list of great resources to help aid in your development processes.
                        </p>

                        <p className="text-sm mb-0"> Argon Dashboard Documentation.</p>
                        <p className="text-sm mb-0"><a href="https://demos.creative-tim.com/argon-dashboard-pro-react/#/admin/dashboard" target="_blank" rel="noopener noreferrer">https://demos.creative-tim.com/argon-dashboard-pro-react/#/admin/dashboard</a> </p>
                        <p className="text-sm"><a href="https://demos.creative-tim.com/argon-dashboard-pro-react/#/documentation/overview" target="_blank" rel="noopener noreferrer">https://demos.creative-tim.com/argon-dashboard-pro-react/#/documentation/overview</a> </p>

                        <p className="text-sm mb-0"> Amazing SVG and PNG images.</p>
                        <p className="text-sm"><a href="https://undraw.co/" target="_blank" rel="noopener noreferrer">https://undraw.co/</a> </p>

                        <p className="text-sm mb-0"> Royalty free images that can be used anywhere.</p>
                        <p className="text-sm"><a href="https://pixabay.com/" target="_blank" rel="noopener noreferrer">https://pixabay.com/</a> </p>

                        <p className="text-sm mb-0"> Icons for the web, if you don't know what this is...</p>
                        <p className="text-sm"><a href="https://fontawesome.com/icons?from=io" target="_blank" rel="noopener noreferrer">https://fontawesome.com/icons?from=io</a> </p>

                        <p className="text-sm mb-0">A well designed box shadow creator.</p>
                        <p className="text-sm"><a href="https://brumm.af/shadows" target="_blank" rel="noopener noreferrer">https://brumm.af/shadows</a> </p>

                    </CardBody>
                </Card>
          
            </Container>
            </>
        );
    }
}

export default Resources